module.exports = __webpack_public_path__ + "static/media/logo.15d208a2.png";